var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"sf",class:{ 'sf--static': _vm.reduced },attrs:{"aria-hidden":"true"}},_vm._l((_vm.cells),function(cell,idx){return _c('sfc_cell',{key:idx,attrs:{"cell":cell}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }